import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import _ from 'lodash'
import { Text, PopupTooltip, Grid, hooks } from '@adc/ui-adc'
import { getFieldValue, pruneFields } from '../redesign/propertyDetails/utils'
import cls from './index.scss'
const cx = _cx.bind(cls)

const PropertyDetailsRow = ({ listing }) => (
  <div className={cx('property-details')}>
    <Grid className={cx('property-details-grid')} padded>
      {pruneFields(listing).map((field, index) => {
        const firstField = field[0]
        const firstFieldValue = getFieldValue(firstField)
        const firstLabel = _.isFunction(firstField.label)
          ? firstField.label(listing)
          : firstField.label
        const hideFirstField = firstField.hideIfNull && !firstFieldValue
        // Just don't show the second value if it doesn't exists. This can only happen once because of `pruneFields`
        const secondField = _.get(field, '[1]', { hideIfNull: true })
        const secondFieldValue = getFieldValue(secondField)
        const secondLabel = _.isFunction(secondField.label)
          ? secondField.label(listing)
          : secondField.label
        const hideSecondField = secondField.hideIfNull && !secondFieldValue
        return (
          <React.Fragment key={index}>
            <Grid.Column
              mobile={8}
              computer={4}
              className={cx('property-details-column', 'first-column')}
            >
              <Text color='gray' data-elm-id={`${firstField.elmId}_label`}>
                {!hideFirstField && firstLabel}
              </Text>
            </Grid.Column>
            <Grid.Column
              mobile={8}
              computer={4}
              className={cx('property-details-column')}
            >
              {!hideFirstField && (
                <PropertyDetailFieldValue
                  fieldValue={firstFieldValue}
                  fieldName={firstField.elmId}
                />
              )}
            </Grid.Column>
            <Grid.Column
              mobile={8}
              computer={4}
              className={cx('property-details-column')}
            >
              <Text color='gray' data-elm-id={`${secondField.elmId}_label`}>
                {!hideSecondField && secondLabel}
              </Text>
            </Grid.Column>
            <Grid.Column
              mobile={8}
              computer={4}
              className={cx('property-details-column')}
              style={{ whiteSpace: 'nowrap' }}
            >
              {!hideSecondField && (
                <PropertyDetailFieldValue
                  fieldValue={secondFieldValue}
                  fieldName={secondField.elmId}
                />
              )}
            </Grid.Column>
          </React.Fragment>
        )
      })}
    </Grid>
  </div>
)

PropertyDetailsRow.propTypes = {
  listing: PropTypes.object.isRequired,
}

const PropertyDetailFieldValue = ({ fieldValue, fieldName }) => {
  const isMobile = hooks.useIsMobileHook()
  return !isMobile && fieldValue && fieldValue.length > 13 ? (
    <PopupTooltip
      position='top center'
      trigger={
        <Text color='gray' weight='heavy' data-elm-id={`${fieldName}_value`}>
          {fieldValue.slice(0, 13)}...
        </Text>
      }
      content={fieldValue}
    />
  ) : (
    fieldValue && (
      <Text color='gray' weight='heavy' data-elm-id={`${fieldName}_value`}>
        {fieldValue}
      </Text>
    )
  )
}
export default PropertyDetailsRow
